//Sets given cookie name and value for given amount of days
const setSessionCookie = (cname, cvalue) => {        
    document.cookie =
    cname + "=" + cvalue + ";" + "path=/; secure";
};

function dataLayerAdClick(){ 
    if(this.getAttribute("href").charAt(0) != "#") {
        const name = this.getAttribute("name");
        const position = this.getAttribute("position");
        const creative = this.getAttribute("creative");
        const campaignID = this.getAttribute("campaignid");

        if(campaignID) {
            setSessionCookie("personalizationPromoID", campaignID);
        } else {
            setSessionCookie("personalizationPromoID", name);
        }
        
        setSessionCookie("personalizationPromo", name);

        var personalizationPromoURL = this.getAttribute("href");

        if(personalizationPromoURL.includes("?")) {
            personalizationPromoURL = personalizationPromoURL.split("?")[0]
        }

        personalizationPromoURL = personalizationPromoURL.replace("https://" + window.location.hostname, "")

        setSessionCookie("personalizationPromoURL", personalizationPromoURL);

        dataLayer.push({
        'event': 'promotionClick',
            'ecommerce': {
            'promoClick': {
            'promotions': [                     
                    {
                    'id': this.getAttribute("campaignid") ? this.getAttribute("campaignID") : name,
                    'name': name, // same as ID
                    'creative': creative, // location of "promo"
                    'position': position // slot on carousel or page 
                }]
            }
            }
        });
        // return false;
    }
}

//Event listener to wait for scripts to load before running SF code
window.addEventListener("load", (event) => {            
    if (window.dataLayer) {
        var CTAelements = document.getElementsByClassName("dataLayerAdClickCTA");
        var viewElements = document.getElementsByClassName("dataLayerAdView");
    
    
        for (var i = 0; i < CTAelements.length; i++) {            
            CTAelements[i].addEventListener('click', dataLayerAdClick, false);
        }

        var promoArray = [];
        var promoObject;
    
        for (var i = 0; i < viewElements.length; i++) {         
            if(viewElements[i].getAttribute("promoURL").charAt(0) != "#") {    
                promoObject = {
                    'id': viewElements[i].getAttribute("campaignID") ? viewElements[i].getAttribute("campaignID") : viewElements[i].getAttribute("name"),
                    'name': viewElements[i].getAttribute("name"),
                    'creative': viewElements[i].getAttribute("creative"),
                    'position': viewElements[i].getAttribute("position")
                }

                promoArray.push(promoObject);
            }       
        }

        if (promoArray.length) {
            dataLayer.push({
                'event': 'promotionView',
                'ecommerce': {
                    'promoView': {
                        'promotions': promoArray
                    }
                }
            });	
        }        
    }
});